module.exports = __webpack_public_path__ + "img/img_judges4.aec8f60c.png";